import Navbar from "../Components/Navbar";
import Wip from "../Components/Wip";
import Footer from "../Components/Footer";

const Films = () => {
    return (
        <div>
            <Navbar />
            <Wip />
            <Footer />
        </div>
    );
}

export default Films;